import type { PersonRecordCreators } from "../types/involvement.js";
import type { OrganisationId } from "../types/organisation.js";

/**
 * One entry per person record, the surviving one first, so an organisation
 * that created two of the person's records appears twice.
 */
export const organisationsThatCreatedPersonRecords = (
  person: PersonRecordCreators,
): OrganisationId[] => [
  person.createdByOrganisationId,
  ...person.mergedPersonRecords.map((record) => record.createdByOrganisationId),
];
